import { FascicoloFull } from './fascicolo/fascicolo-full';
import { PraticaFull } from './pratica/pratica-full';

export class EntityCached {
  idLastEntity: string;
  praticaFull: PraticaFull;
  fascicoloFull: FascicoloFull;

  constructor(idLastEntity: string, praticaFull: PraticaFull, fascicoloFull: FascicoloFull) {
    this.idLastEntity = idLastEntity;
    this.praticaFull = praticaFull;
    this.fascicoloFull = fascicoloFull;
  }
}
